import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {environment} from '../../../environments/environment';
import {HttpRequestService} from '../../shared/services/http-request.service';

@Injectable()
export class EventDetailsService {
  private getEventDetailsURL = environment.apiUrl + '/EventCms/Get';
  private getMailTemplatesURL = environment.apiUrl + '/EventCms/GetMailTemplates';
  private getEventUpdateURL = environment.apiUrl + '/EventCms/Update';
  private getEventNewURL = environment.apiUrl + '/EventCms/NewEvent';
  private getEventDeleteURL = environment.apiUrl + '/EventCms/DeleteEvent';
  private getUpdateEventHtmlFieldsURL = environment.apiUrl + '/EventCms/UpdateEventHtmlFields';



  constructor(private _http: HttpRequestService) {
  }

  getEventDetails(id) {
    return this._http.get(this.getEventDetailsURL + '?id=' + id);
  }

  getMailTemplates() {
    return this._http.get(this.getMailTemplatesURL);
  }

  update(request, files) {
    return this._http.postMultipart(this.getEventUpdateURL, request, files);
  }

  new(request, files) {
    return this._http.postMultipart(this.getEventNewURL, request, files);
  }

  delete(id) {
    return this._http.get(this.getEventDeleteURL + '?id=' +  id, true);

  }

  updateEventHtmlFields(model) {
    return this._http.post(this.getUpdateEventHtmlFieldsURL, model, true);
  }
}




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-details/event-details.service.ts